import React__default, { useContext } from 'react';

const RuleBuilderStepsContext = /*#__PURE__*/React__default.createContext({
  activeStep: 0
});
const useRuleBuilderStepsContext = () => useContext(RuleBuilderStepsContext);
const RuleBuilderStepsProvider = ({
  value,
  children
}) => {
  const isError = value.state === 'error';
  const isLoading = value.state === 'loading';
  return /*#__PURE__*/React__default.createElement(RuleBuilderStepsContext.Provider, {
    value: {
      ...value,
      isError,
      isLoading
    }
  }, children);
};
RuleBuilderStepsProvider.displayName = "RuleBuilderStepsProvider";

export { RuleBuilderStepsProvider, useRuleBuilderStepsContext };
